import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Tooltip } from '@material-ui/core';

import { PainPoint } from '../PainPoint';
import {
  DEFAULT_ROWS_COUNT,
  calculateItemsProps,
  calculatePanelHeight,
  prepareMorePainsTooltip,
} from './utils';
import { useStyles } from './useStyles';

const onlyValidElements = (items) => items.filter(({ element }) => element);

export const PainsPositioner = ({ className, pains }) => {
  const styles = useStyles();

  const refElementsInfo = useRef([]);
  const [itemsStyles, setItemsStyles] = useState([]);
  const [rowsCount, setRowsCount] = useState(DEFAULT_ROWS_COUNT);
  const [moreCount, setMoreCount] = useState(0);
  const [moreStyles, setMoreStyles] = useState({});

  const storeItemRef = (index, element) => {
    const elementsInfo = refElementsInfo.current;

    elementsInfo[index] = { element };
    if (element) {
      elementsInfo[index].width = element.clientWidth;
    }
  };

  useEffect(() => {
    // This "effect" gets triggered after component is rendered and we have all "pain point" refs
    // we just need to cut "empty" elements, in case number of "pains" dropped
    const elementsInfo = onlyValidElements(refElementsInfo.current);

    const newProps = calculateItemsProps(elementsInfo);
    setItemsStyles(newProps.itemsStyles);
    setRowsCount(newProps.rowsCount);
    setMoreCount(newProps.moreCount);
    setMoreStyles(newProps.moreStyles);
  }, [pains]);

  const morePainsTooltip = useMemo(
    () => prepareMorePainsTooltip(pains, itemsStyles),
    [pains, itemsStyles]
  );

  return (
    <div
      className={cx(styles.root, className)}
      style={{ height: calculatePanelHeight(rowsCount) }}
    >
      {pains.map((pain, index) => (
        <PainPoint
          className={styles.pain}
          ref={(ref) => storeItemRef(index, ref)}
          key={pain}
          style={itemsStyles[index]}
          text={pain}
        />
      ))}

      {moreCount > 0 && (
        <Tooltip title={morePainsTooltip}>
          <PainPoint
            className={styles.pain}
            text={`+${moreCount}`}
            style={moreStyles}
          />
        </Tooltip>
      )}
    </div>
  );
};

PainsPositioner.propTypes = {
  className: PropTypes.string,
  pains: PropTypes.arrayOf(PropTypes.string).isRequired,
};
PainsPositioner.defaultProps = {
  className: null,
};
